export default __webpack_public_path__ + "static/media/ic_instagram.3315e885.svg";